module.exports = __webpack_public_path__ + "static/media/20201216_183456_683_IMG_3131.2561d883.jpg";